import inputMasking from '@/helpers/input-masking'

export default function (Vue) {
  /**
   * @description Currency masking on input fields
   * Attachs events listeners to multiple input fields where v-currency-mask directive is added
   * Focus Listener Event is used to convert the currency format into an number
   * Blur Listener Event is used to convert the number into currency format
   * @author NevetsKuro
   * @date 2022/04/24
   */
  Vue.directive('currencyMask', {
    inserted: (el, binding, vnode) => {
      el.addEventListener('focus', (e) => {
        if (e.target.value) {
          e.target.value = inputMasking.stripNaN(e.target.value)
          vnode.elm.dispatchEvent(new CustomEvent('input'))
        }
      })
      el.addEventListener('blur', (e) => {
        let targetValue = e.target.value
        if (isNaN(Number(targetValue))) {
          targetValue = inputMasking.stripNaN(targetValue)
        }
        if (targetValue) {
          e.target.value = inputMasking.convertToCurrency(targetValue)
          vnode.elm.dispatchEvent(new CustomEvent('input'))
        }
      })
    }
  })
  /**
   * @description Convert input field values to uppercase
   */
  Vue.directive('uppercase', {
    update: function (el) {
      el.value = el.value.toUpperCase()
    }
  })
}
